module.exports = __webpack_public_path__ + "static/media/Video.8f72c0d4.svg";